<template>
  <svg
    version="1.1"
    id="레이어_3"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 71 72.7"
    style="enable-background:new 0 0 71 72.7;"
    xml:space="preserve"
  >
    <path
      class="st0"
      d="M56,15.9c-5.3-5.2-12.5-8.5-20.5-8.5c-16,0-29,13-29,29c0,16,13,29,29,29s29-13,29-29
	C64.5,28.4,61.2,21.1,56,15.9z"
    />
    <path
      class="st1"
      d="M42,31.3c-1.7-1.5-3.8-2.4-6.1-2.4c-2.4,0-4,0.9-4,2.8c0,4,12.7,2.6,12.7,10.5c0,3.7-2.5,6.4-7.2,7v4.2h-3.2v-4
	c-2.7-0.3-6-1.3-8-3.2l2.2-3.2c1.9,1.7,4.3,2.6,6.8,2.6c3.3,0,4.8-1,4.8-2.9c0-4.2-12.7-2.9-12.7-10.6c0-3.8,2.7-6.4,7-6.8V21h3.1
	v4.1c2.6,0.3,5.1,1.5,7,3.3L42,31.3z"
    />
    <path
      class="st0"
      d="M2.1,17.1c-1.1,0-2.1-0.9-2.1-2.1v-13C0,0.9,0.9,0,2.1,0h13.4c1.1,0,2.1,0.9,2.1,2.1s-0.9,2.1-2.1,2.1H4.1v11
	C4.1,16.3,3.2,17.1,2.1,17.1z"
    />
    <path
      class="st0"
      d="M68.9,17.1c-1.1,0-2.1-0.9-2.1-2.1v-11H55.5c-1.1,0-2.1-0.9-2.1-2.1S54.4,0,55.5,0c0,0,0,0,0,0h13.4
	C70,0,71,0.9,71,2v13C71,16.2,70.1,17.1,68.9,17.1C68.9,17.1,68.9,17.1,68.9,17.1z"
    />
    <path
      class="st0"
      d="M15.5,72.7H2.1c-1.1,0-2-0.9-2.1-2v-13c0.1-1.1,1.1-2,2.2-1.9c1,0.1,1.8,0.9,1.9,1.9v11h11.4
	c1.1-0.3,2.2,0.4,2.5,1.5c0.3,1.1-0.4,2.2-1.5,2.5C16.2,72.8,15.8,72.8,15.5,72.7z"
    />
    <path
      class="st0"
      d="M68.9,72.7H55.5c-1.1,0-2.1-0.9-2.1-2.1c0-1.1,0.9-2.1,2.1-2.1h11.4V57.7c0.1-1.1,1.1-2,2.2-1.9
	c1,0.1,1.8,0.9,1.9,1.9v13C71,71.9,70,72.7,68.9,72.7z"
    />
  </svg>
</template>

<script>
export default {
  name: 'PayFillIcon',
};
</script>

<style scoped>
.st0 {
  fill: #3e0ba5;
}
.st1 {
  fill: #ffffff;
}
</style>
